import { toggleSidebar } from 'features/sidebar/sidebarTogglingSlice';
import { FC } from 'react';
import { useDispatch } from 'react-redux';

const ResponsiveBurgerButton: FC = () => {
  const dispatch = useDispatch();

  return (
    <button
      onClick={() => dispatch(toggleSidebar())}
      className="visible sm:visible"
    >
      <span className="transition-all h-1 w-6 mb-1 bg-white rounded block"></span>
      <span className="transition-all h-1 w-6 mb-1 bg-white rounded block"></span>
      <span className="transition-all h-1 w-6 bg-white rounded block"></span>
    </button>
  );
};

export default ResponsiveBurgerButton;
